import { Icon } from 'Icon'

export default function Podcasts() {
    return (
        <>
            <div className="bg-purple-900 h-84 absolute top-0 left-0 w-full z-[-1] before:h-full before:absolute before:inset-0 before:w-full before:bg-gradient-to-t before:from-black/50 before:to-transparent"></div>
            <div className="flex items-center gap-x-6 pt-6">
                <div className="w-56 h-56 bg-gradient-to-br shadow-spotify-shadow from-purple-700 to-indigo-300 flex items-center justify-center">
                    <Icon src="hearth" size={85} />
                </div>
                <div>
                    <div className="text-xs font-semibold mb-2">PLAYLIST</div>
                    <div className="text-8xl font-bold tracking-tighter">Liked Songs</div>
                </div>
            </div>
        </>
    )
}
